import { installAnalytics } from "./lib/marketing_analytics"

installAnalytics(window, document)
